export default "__VITE_PUBLIC_ASSET__ccc336c3__"